import { put } from '@alltrails/core/utils/put';
import type { Review } from '@alltrails/types/Review';
import type { TrailId } from '@alltrails/types/TrailId';

type HideSummaryResponse = {
  trail_id: TrailId;
  hide_summary: boolean;
  review_summary?: string;
};

export const updateHideSummary = (trailId: TrailId, hideSummary: boolean) =>
  put<HideSummaryResponse>(`/api/alltrails/admin/trails/${trailId}/review_summary`, { hide_summary: hideSummary });

type SummaryExclusionResponse = {
  trail_id: TrailId;
  review_id: Review['id'];
  summary_exclusion: boolean;
  review_summary?: string;
};

export const updateSummaryExclusion = (review: Review, summaryExclusion: boolean) =>
  put<SummaryExclusionResponse>(`/api/alltrails/admin/trails/${review.trailId}/reviews/${review.id}/review_summary`, {
    summary_exclusion: summaryExclusion
  });
